<template>
  <v-container
    id="recibos-produtor-form"
    fluid
    tag="section"
  >
    <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO -->
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('recibos-pgto-leite')"
    />

    <base-material-card
      v-else
      color="primary"
      icon="mdi-cash-check"
      :title="$t('recibos-pgto-leite')"
      :app-online="appOnline"
    >
      <v-row>
        <v-col
          cols="12"
          lg="12"
        >
          <v-skeleton-loader
            v-if="loading_laticinios"
            type="table-heading, table-tbody, table-tfoot"
          />
          <div v-else>
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="pesquisar(laticinio.select.id, new Date(date).toISOString().substr(0, 10))"
            >
              <v-row>
                <v-col
                  cols="12"
                  lg="8"
                >
                  <v-select
                    :v-model="laticinio.select"
                    :items="laticinio.items"
                    item-text="nome"
                    item-value="id"
                    :success="true"
                    :disabled="disabledSelectLaticinio"
                    return-object
                    :label="laticinio.label"
                    @change="onChange($event)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                >
                  <v-menu
                    ref="menuData"
                    v-model="menuData"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        v-mask="maskDateFormatted"
                        :rules="DateFormattedRules"
                        :disabled="disabledSelectDate"
                        :success="true"
                        label="Período"
                        v-on="on"
                      >
                        <template
                          v-if="true"
                          v-slot:append-outer
                        >
                          <v-btn
                            :disabled="!valid"
                            class="mt-n2"
                            elevation="1"
                            fab
                            small
                            color="primary"
                            type="submit"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      no-title
                      @input="menuData = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-skeleton-loader
            v-if="loading"
            height="250"
            type="table-tbody"
          />
          <v-data-table
            v-else
            :headers="titulosListaRecibos"
            :items="listaRecibos"
            :items-per-page="5"
            disable-pagination
            hide-default-footer
            disable-sort
          >
            <template v-slot:[`item.datainicio`]="{ item }">
              <v-label class="primary--text">
                {{ formatDiaMesAno(item.datainicio) }}
              </v-label>
            </template>
            <template v-slot:[`item.datafim`]="{ item }">
              <v-label>
                {{ formatDiaMesAno(item.datafim) }}
              </v-label>
            </template>
            <template v-slot:[`item.datapagamento`]="{ item }">
              <v-label>
                {{ formatDiaMesAno(item.datapagamento) }}
              </v-label>
            </template>
            <template
              v-slot:[`item.total`]="{ item }"
            >
              <label>
                {{ parseMoeda(item.total,2) }}
              </label>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <v-btn
                class="px-2 ml-1"
                min-width="0"
                color="primary"
                @click="ExibeItensRecibo(item.id)"
              >
                Detalhar
              </v-btn>
            </template>
            <template v-slot:[`body.append`]>
              <tr
                v-if="$vuetify.breakpoint.xs"
                class="totalizador"
              >
                <td class="text-right">
                  <strong>Total: </strong>{{ parseMoeda(soma,2) }}
                </td>
              </tr>
              <tr
                v-else
                class="totalizador"
              >
                <td>
                  <strong>Total:</strong>
                </td>
                <td
                  colspan="2"
                />
                <td>
                  <strong>{{ parseMoeda(soma,2) }}</strong>
                </td>
                <td />
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <dashboard-core-snackbar
          v-model="snackbar.visible"
          :visible="snackbar.visible"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          :message="snackbar.message"
        />
        <itens-recibo-form
          :recibo="reciboSelecionado"
          :itensrecibo="listaItensRecibo"
          :empresarecibo="empresaDoRecibo"
          :exibedialog="dialog"
          @update-dialog="updateDialog"
        />
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import RecibosProdutorService from '../../../services/recibosprodutorservice'
  import ItensReciboForm from '../forms/ItensReciboForm'
  import utils from '../../../services/utils'

  export default {
    name: 'DashboardFormsRecibosProdutorForm',
    components: {
      ItensReciboForm,
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      valid: true,
      disabledSelectLaticinio: false,
      disabledSelectDate: false,
      date: new Date().toISOString().substr(0, 10),
      maskDateFormatted: '##/####',
      DateFormattedRules: [
        v => /^\d{2}\/\d{4}$/.test(v),
      ],
      menuData: false,
      listaRecibos: [],
      listaItensRecibo: [],
      laticinio: {
        label: 'Laticínio',
        select: { id: 0, nome: 'Nenhuma informação encontrada' },
        items: [
          { id: 0, nome: 'Nenhuma informação encontrada' },
        ],
        totalQtde: 0,
      },
      datainicio: '',
      datafim: '',
      user: {
        username: '',
        roles: '["ROLE_PRODUTOR"]',
        password: '',
      },
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      empresaDoRecibo: {},
      reciboSelecionado: {},
      titulosListaRecibos: [
        {
          text: 'Data Início',
          align: 'start',
          sortable: true,
          value: 'datainicio',
        },
        { text: 'Data Fim', sortable: true, value: 'datafim' },
        { text: 'Data Pgto', sortable: true, value: 'datapagamento' },
        { text: 'Valor', sortable: true, value: 'total' },
        { text: '', align: 'end', sortable: true, value: 'id' },
      ],
      soma: 0,
      loading: false,
      loading_laticinios: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    mounted () {
      // this.verificaVersao()
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
        }
      } else {
        localStorage.clear()
        this.$router.push('/pages/usuarioprodutor')
      }
    },
    methods: {
      carregaForm () {
        this.pesquisar(-1, this.date)
      },

      pesquisar (idLaticinio, mesAnoFiltro) {
        if (idLaticinio === -1) {
          this.carregaLaticinios(mesAnoFiltro)
        } else if (idLaticinio === 0) {
          this.showSnackbar('warning', 3000, 'Selecione um laticínio antes de pesquisar.')
        } else {
          var laticinio = this.laticinio.items.find(item => item.id === idLaticinio)
          this.loading = true
          this.carregaRecibos(idLaticinio, laticinio.produtor_id, mesAnoFiltro)
          this.empresaDoRecibo = this.laticinio.items.find((item) => item.id === idLaticinio)
        }
      },

      carregaLaticinios (dataFiltro) {
        this.loading_laticinios = true

        RecibosProdutorService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
          if (resposta.data.empresas.length > 0) {
            this.laticinio.items = resposta.data.empresas

            var idProdutor = resposta.data.empresas[0].produtor_id

            if (resposta.data.empresas.length === 1) {
              this.laticinio.select = resposta.data.empresas[0]
              this.laticinio.label = resposta.data.empresas[0].nome
              this.disabledSelectLaticinio = true
              this.carregaRecibos(resposta.data.empresas[0].id, idProdutor, dataFiltro)
              this.empresaDoRecibo = this.laticinio.items.find((item) => item.id === resposta.data.empresas[0].id)
            }
          }

          this.loading_laticinios = false
          this.disabledSelectDate = false
          this.appOnline = true
          this.verificaVersao(resposta.data.versao_vue)
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listarLaticinios(): ' + e.response)
            this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },

      carregaRecibos (idLaticinio, idProdutor, dataFiltro) {
        var primeiroDiaDoMes = this.getFirstDayOfMonth(dataFiltro)

        RecibosProdutorService.listarRecibos(idLaticinio, idProdutor, primeiroDiaDoMes).then(resposta => {
          this.listaRecibos = resposta.data.recibos

          this.listaItensRecibos = resposta.data.itens_recibos

          this.calculaTotais()

          if (this.listaRecibos.length > 0) {
            this.salvaDadosOffline()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listar(): ' + e.response)
          }
          this.loading = false
        })
      },

      onChange (event) {
        this.laticinio.select = event
        this.dialog = false
      },

      ExibeItensRecibo (idRecibo) {
        // Ao inves de buscar pelo id na api vai apenas buscar na lista com todos os itens de recibo desse produtor
        this.listaItensRecibo = this.listaItensRecibos.filter(item => item.recibo.id === idRecibo)
        this.empresaDoRecibo = this.listaRecibos.find(item => item.id === idRecibo).empresa

        this.reciboSelecionado = this.listaRecibos.find(item => item.id === idRecibo)
        this.dialog = true
      },

      updateDialog (dialog) {
        this.dialog = dialog
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      calculaTotais () {
        this.soma = this.listaRecibos.reduce((soma, item) => (soma + item.total), 0)
        this.loading = false
      },

      salvaDadosOffline () {
        try {
          localStorage.laticinioSelecionadoRecibos = this.laticinio.label
          localStorage.mesSelecionadoRecibos = this.date
          const parsed1 = JSON.stringify(this.listaRecibos)
          localStorage.setItem('listaRecibos', parsed1)
          const parsed2 = JSON.stringify(this.listaItensRecibos)
          localStorage.setItem('listaItensRecibos', parsed2)
        } catch (e) {
        }
      },

      carregaDadosOffline () {
        this.appOnline = false
        this.laticinio.label = localStorage.laticinioSelecionadoRecibos
        this.date = localStorage.mesSelecionadoRecibos
        this.disabledSelectLaticinio = true
        this.disabledSelectDate = true

        if (localStorage.getItem('listaRecibos')) {
          try {
            this.listaRecibos = JSON.parse(localStorage.getItem('listaRecibos'))
            this.listaItensRecibos = JSON.parse(localStorage.getItem('listaItensRecibos'))
            this.calculaTotais()
          } catch (e) {
            localStorage.removeItem('listaRecibos')
            localStorage.removeItem('listaItensRecibos')
          }
        }
      },
    },
  }
</script>

<style scoped>
  .quitado { color: green; }
  .cancelado { color: red; }
  .totalizador { background-color: rgba(78, 119, 173, 0.2);}
  .totalizador td { font-weight: 500;}
  .v-data-table table thead tr th {font-weight: 400;}
  .theme--light.v-label {
    color: rgba(0, 0, 0, 0.7);
}
</style>
